import styled, { css } from 'styled-components';

export const StyledLabel = styled.label`
	${({ theme }) => css`
		display: flex;
		align-items: center;
		gap: ${theme.spacing.sm};
		cursor: pointer;

		&:hover .checkbox-icon,
		&:active .checkbox-icon {
			background-color: ${theme.colors.bgHover};
			border-radius: ${theme.borderRadii.sm};
		}

		&:focus-within .checkbox-icon {
			background-color: ${theme.colors.bgSelected};
			border-radius: ${theme.borderRadii.sm};
			box-shadow: inset 0 0 0 1px ${theme.colors.borderFocus};
		}
	`}
`;

export const HiddenInput = styled.input`
	position: absolute;
	opacity: 0;
	cursor: pointer;
	height: 0;
	width: 0;
`;
